import { useTranslation } from "next-i18next";
import { useMemo } from "react";
import { ObjectSchema, ValidationError as YupValidationError } from "yup";

export enum ValidationErrorType {
  Required = "required",
  Min = "min", // Min length
  greaterThanRolling = "greaterThanRolling",
}

export interface ValidationError {
  type: ValidationErrorType;
  fieldName: string;
  message: string;
}

function useValidationSync<T>(schema: ObjectSchema<any>, formValues: T) {
  const { t } = useTranslation();

  const ERROR_MESSAGES = useMemo(
    () => ({
      [ValidationErrorType.Required]: t("errors.required_field"),
      [ValidationErrorType.Min]: t("errors.tell_more"),
      [ValidationErrorType.greaterThanRolling]: t(
        "errors.relevence.projects.5years"
      ),
    }),
    [t]
  );

  return useMemo(() => {
    try {
      schema.validateSync(formValues, { abortEarly: false });
      return null;
    } catch (err) {
      if (err instanceof YupValidationError) {
        return err.inner.reduce((acc, x) => {
          return {
            ...acc,
            ...(x.path && {
              [x.path as string]: {
                type: x.type,
                fieldName: x.path,
                message:
                  ERROR_MESSAGES[x.type as ValidationErrorType] || x.message,
              } as ValidationError,
            }),
          };
        }, {});
      }
    }
  }, [formValues, ERROR_MESSAGES, schema]);
}

export default useValidationSync;
